<template>
    <div class="w-[45px] aspect-square rounded-full flex items-center justify-center relative overflow-visible"
         :class="randomBackground">
        <div class="text-white" :class="textSize">{{ initials }}</div>

        <span v-if="verified"
              class="absolute -bottom-1 -right-1 border-2 border-white rounded-full w-5 h-5 flex items-center justify-center bg-gradient-to-tr from-green-100 to-green-200">
            <FontAwesomeIcon size="xs" class="text-white" :icon="['far', 'check']"></FontAwesomeIcon>
        </span>
    </div>
</template>

<script>
import Numbers from "@/Mixins/Utilities/Numbers";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {FontAwesomeIcon},
    mixins: [Numbers],
    props: {
        user: Object,
        verified: Boolean,
        textSize: {
            type: String,
            default: "text-lg"
        }
    },
    computed: {
        randomBackground() {
            const backgrounds = ["bg-primary", "bg-secondary"];

            const index = this.randomNumberBetween(0, backgrounds.length);

            return backgrounds[index];
        },
        initials() {
            const names = this.user.name.split(" ");

            return names.map(name => name[0].toUpperCase()).join("");
        }
    }
};
</script>

<style scoped>

</style>
